import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

const environment = process.env.VUE_APP_SENTRY_ENV

export function useSentry (app, user) {
  if (!environment) {
    return
  }

  Sentry.init({
    enabled: !!environment,
    app,
    dsn: 'https://4c948fea573e47fbaefd6be4f7c88466@ei-sentry.funplus.com.cn/6',
    environment,
    logErrors: true,
    autoSessionTracking: true,
    // 性能监控
    integrations: [
      new Integrations.BrowserTracing({
        beforeNavigate (context) {
          return {
            ...context,
            name: location.pathname
              .replace(/\/users\/\d+\/okr/, '/users/:userId/okr')
          }
        }
      })
    ],
    tracesSampleRate: 1.0
  })

  Sentry.setUser({
    id: user.uid,
    name: user.name
  })
}
